import { Link } from 'react-router-dom'

const footerLinks = {
  product: [
    { name: 'Home', href: '/' },
    { name: 'Features', href: '/features' },
    { name: 'Pricing', href: '/pricing' },
    { name: 'Security', href: '/security' },
  ],
  company: [
    { name: 'About Us', href: '/about' },
    { name: 'Referral Program', href: '/referral' },
    { name: 'Careers', href: '/careers' },
    { name: 'Contact', href: '/contact' },
  ],
  legal: [
    { name: 'Privacy Policy', href: '/privacy' },
    { name: 'Terms of Service', href: '/terms' },
    { name: 'Cookie Policy', href: '/cookies' },
  ],
}

export function Footer() {
  return (
    <footer className="bg-surface-900 text-white">
      <div className="mx-auto max-w-7xl section-padding py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/">
              <img src="/ledger-logo-white.svg" alt="Ledger" className="h-8 w-auto" />
            </Link>
            <p className="mt-4 text-surface-400 text-sm max-w-xs">
              Simple bookkeeping for micro and small businesses in Sri Lanka. Replace your paper ledger today.
            </p>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-sm font-semibold text-white">Product</h3>
            <ul className="mt-4 space-y-3">
              {footerLinks.product.map((item) => (
                <li key={item.name}>
                  <Link to={item.href} className="text-sm text-surface-400 hover:text-white transition-colors">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white">Company</h3>
            <ul className="mt-4 space-y-3">
              {footerLinks.company.map((item) => (
                <li key={item.name}>
                  <Link to={item.href} className="text-sm text-surface-400 hover:text-white transition-colors">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white">Legal</h3>
            <ul className="mt-4 space-y-3">
              {footerLinks.legal.map((item) => (
                <li key={item.name}>
                  <Link to={item.href} className="text-sm text-surface-400 hover:text-white transition-colors">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-surface-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-surface-500 text-sm">
            © {new Date().getFullYear()} Ledger. All rights reserved.
          </p>
          <a 
            href="https://www.nanthiventures.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-surface-500 text-sm hover:text-surface-300 transition-colors"
          >
            A Nanthi Ventures company
          </a>
        </div>
      </div>
    </footer>
  )
}

